module.exports = require("next/dist/shared/lib/no-fallback-error.external.js");